exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".fileList__2Ewn {\n  max-height: 400px;\n  overflow: auto; }\n", "", {"version":3,"sources":["/app/src/components/src/components/UnsupportedFileUploadModal.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe,EAChB","file":"UnsupportedFileUploadModal.scss","sourcesContent":[".fileList {\n  max-height: 400px;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"fileList": "fileList__2Ewn"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/UnsupportedFileUploadModal.scss
// module id = 764
// module chunks = 0